export * from '@src/components/templates/tefOne/consent.tmpl.js';
export * from '@src/components/templates/tefOne/features.tmpl.js';
export * from '@src/components/templates/tefOne/footer.tmpl.js';
export * from '@src/components/templates/tefOne/group.tmpl.js';
export * from '@src/components/templates/tefOne/template.tmpl.js';
export * from '@src/components/templates/tefOne/viewTemplate.tmpl.js';
export * from '@src/components/templates/tefOne/tooltip.tmpl.js';
export * from '@src/components/templates/tefOne/link.tmpl.js';
export * from '@src/components/templates/tefOne/em.tmpl.js';
export * from '@src/components/templates/tefOne/comsParagraph.tmpl.js';
export * from '@src/components/templates/tefOne/comsText.tmpl.js';
export * from '@src/components/templates/tefOne/mergeAccountsWrapper.tmpl.js';
export * from '@src/components/templates/tefOne/tefComsCustomerAttribute.tmpl.js';
